import Link from '@lsfe/components/components/Link/index';
import LoadingButton from '@lsfe/components/components/LoadingButton/index';
import Panel from '@lsfe/components/components/Panel/index';
import SearchForm from '@lsfe/components/components/SearchForm/index';
import TablePro from '@lsfe/components/components/TablePro/index';
import Select from '@lsfe/components/components/Select/index';
import PrintTemplate from '@lsfe/components/components/PrintTemplate/index';
import PrintTemplateGroup from '@lsfe/components/components/PrintTemplate/PrintTemplateGroup';
import RichTextEditor from '@lsfe/components/components/RichTextEditor/index';
import DetailCard from '@lsfe/components/components/DetailCard/index';
import EditTable from '@lsfe/components/components/EditTable/index';
import RadioGroup from '@lsfe/components/components/RadioGroup/index';
import Form from '@lsfe/components/components/Form/form';
import FormItem from '@lsfe/components/components/Form/formItem';
import ImageViewer from '@lsfe/components/components/image/src/image-viewer';
import TagTemplate from '@lsfe/components/components/PrintPriceTag/TagTemplate';
import LevelSelect from '@lsfe/components/components/LevelSelect/index';
import PoiSelect from '@lsfe/components/components/XPoiSelect/index';
import Upload from '@lsfe/components/components/Xnupload/index';
import TreeSelect from '@lsfe/components/components/TreeSelect/index';
import XxTreeselect from '@lsfe/components/components/XTreeSelect/index';
import CategorySelect from '@lsfe/components/components/CategorySelect/index';
import XxCategorySelect from '@lsfe/components/components/XCategorySelect/index';
import CheckBoxGroup from '@lsfe/components/components/CheckBoxGroup/index';
import EnumText from '@lsfe/components/components/EnumText/index';
import CitySelect from '@lsfe/components/components/CitySelect/index';
import XUpload from '@lsfe/components/components/XUpload/index';
// import XxImage from '@lsfe/components/components/image/index';
import VideoUpload from '@lsfe/components/components/Upload/VideoUpload/index';
import XxFlowGraph from '@lsfe/components/components/FlowGraph/index';
import XxAuditFlow from '@lsfe/components/components/AuditFlow';
import ValidateInput from '@lsfe/components/components/ValidateInput';
import Image from '@lsfe/components/components/image';
import FileUpload from '@lsfe/components/components/FileUpload';
import Pagination from './Pagination';
import Affix from './Affix';
import Card from './Card';
import CardItem from './CardItem';
import Dashboard from './Dashboard';
import ImageTpl from './ImageTpl';
import PoiSelectForSupplier from './PoiSelectForSupplier';
import PoiSelectForVss from './PoiSelectForVss';
import SimpleSupplierSelect from './SimpleSupplierSelect';
import ByParentSelect from './ByParentSelect';
import CardInfo from './CardInfo';

export default [
    RadioGroup,
    Link,
    Panel,
    SearchForm,
    TablePro,
    LoadingButton,
    Pagination,
    Affix,
    Card,
    CardItem,
    Dashboard,
    PrintTemplate,
    PrintTemplateGroup,
    RichTextEditor,
    Select,
    DetailCard,
    EditTable,
    ImageTpl,
    PoiSelectForSupplier,
    PoiSelectForVss,
    Form,
    FormItem,
    ImageViewer,
    TagTemplate,
    LevelSelect,
    PoiSelect,
    Upload,
    SimpleSupplierSelect,
    ByParentSelect,
    CardInfo,
    TreeSelect,
    ValidateInput,
    XxTreeselect,
    CategorySelect,
    CheckBoxGroup,
    CitySelect,
    XxCategorySelect,
    SimpleSupplierSelect,
    EnumText,
    XUpload,
    // XxImage,
    VideoUpload,
    XxAuditFlow,
    XxFlowGraph,
    Image,
    FileUpload,
];
